import { formatDate, getFormattedAddress } from "../Premises/helpers";
import {
  SortByEnum,
  TaskOverview,
  TasksTableRow,
  TasksTableRows,
  TaskStatusEnum,
} from "./types";

export const mapTasksToTaskTableRows = (
  taskOverviews: TaskOverview[]
): TasksTableRows => {
  return taskOverviews.map((taskOverview) => {
    const addressObj = taskOverview.premise;

    const address = getFormattedAddress(addressObj);

    return {
      serviceType: taskOverview.service_type,
      connectionType: taskOverview.connection_type,
      address,
      id: taskOverview.request_id,
      taskAdded: formatDate(taskOverview.task_added),
      taskStatus: getStatusIconString(taskOverview.task_status),
      taskStatusText: getStatusText(taskOverview.task_status),
      journeyId: taskOverview.journey_id,
      distributorApplicationId: taskOverview.distributor_application_id,
      requestStatus: taskOverview.task_status,
      state: addressObj.site_details.state,
    };
  });
};

export const getStatusIconString = (taskStatus: TaskStatusEnum): string => {
  const statusIcons = {
    [TaskStatusEnum.NEW_MESSAGE]: "envelope",
    [TaskStatusEnum.ASSIGNED_TO_ME]: "assigned",
    [TaskStatusEnum.COMPLETED]: "connector",
  };
  return statusIcons[taskStatus as keyof typeof statusIcons] || "none";
};

export const getStatusText = (taskStatus: TaskStatusEnum): string => {
  switch (taskStatus) {
    case TaskStatusEnum.NEW_MESSAGE:
      return "New Message";
    case TaskStatusEnum.ASSIGNED_TO_ME:
      return "Assigned to me";
    case TaskStatusEnum.COMPLETED:
      return "Connected - please book closure";
    default:
      return "";
  }
};

export const mapTasksTableRowKeyToSortByEnum = (
  key: keyof TasksTableRow
): SortByEnum | null => {
  const keyToSortByEnumMap: Record<keyof TasksTableRow, SortByEnum | null> = {
    serviceType: null,
    connectionType: SortByEnum.CONNECTION_TYPE,
    address: SortByEnum.ADDRESS,
    id: SortByEnum.REQUEST_ID,
    taskAdded: SortByEnum.TASK_ADDED,
    taskStatus: SortByEnum.TASK_STATUS,
    taskStatusText: SortByEnum.TASK_STATUS,
    journeyId: null,
    distributorApplicationId: null,
    requestStatus: null,
    state: null,
  };

  return keyToSortByEnumMap[key] || null;
};
